import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=4e85abe8&scoped=true&"
import script from "./SecuritySetting.vue?vue&type=script&lang=ts&"
export * from "./SecuritySetting.vue?vue&type=script&lang=ts&"
import style0 from "./SecuritySetting.vue?vue&type=style&index=0&id=4e85abe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e85abe8",
  null
  
)

export default component.exports